import { CapitalTypes } from 'api';

// Keys are used to allow us to assign the same key
// for the same type of request so data can be cached
// with react-query
export const keys = {
  fetch: 'FETCH_CAPITAL_TYPES',
};

export const all = () => {
  return CapitalTypes.all();
};
